import React from 'react';
import { usePlayerContext } from './PlayerContext';
import PlayerViz from './PlayerViz';

const ImageRender: React.FC<any> = () => {
  const { activeBeat } = usePlayerContext();
  
  return (
    <div>
      <PlayerViz
        activeBeat={activeBeat}
        vizSize={600}
        fixedSize
      />
    </div>
  );
};

export default ImageRender;
